import { render, staticRenderFns } from "./CadastroDeSysCategoriaProdutos.vue?vue&type=template&id=f13f7674&scoped=true"
import script from "./CadastroDeSysCategoriaProdutos.vue?vue&type=script&lang=js"
export * from "./CadastroDeSysCategoriaProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13f7674",
  null
  
)

export default component.exports